import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Button, Row, Col, Table, Input, Label, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";

function ListadoIMEIs() {
  const { user } = useContext(AuthContext);
  const URL_IMEIS = process.env.REACT_APP_URL_IMEIS;

  const [imeis, setImeis] = useState([]);
  const [search, setSearch] = useState("");
  const [filterTipo, setFilterTipo] = useState("");
  const [filterFechaInicio, setFilterFechaInicio] = useState("");
  const [filterFechaFin, setFilterFechaFin] = useState("");

  useEffect(() => {
    axios
      .get(URL_IMEIS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setImeis(res.data))
      .catch((err) => console.log(err));
  }, []);

  const filtered = useMemo(() => {
    return imeis.filter((i) => {
      const matchSearch =
        !search ||
        i.imei?.toLowerCase().includes(search.toLowerCase()) ||
        i.articuloNombre?.toLowerCase().includes(search.toLowerCase());
      const matchTipo = !filterTipo || i.tipo === filterTipo;
      const matchFechaInicio = !filterFechaInicio || i.fecha >= filterFechaInicio;
      const matchFechaFin = !filterFechaFin || i.fecha <= filterFechaFin;
      return matchSearch && matchTipo && matchFechaInicio && matchFechaFin;
    });
  }, [imeis, search, filterTipo, filterFechaInicio, filterFechaFin]);

  function eliminarIMEI(id) {
    Swal.fire({
      title: "¿Eliminar IMEI?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${URL_IMEIS}/${id}`, {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          })
          .then(() => {
            setImeis(imeis.filter((i) => i._id !== id));
            Swal.fire("Eliminado", "IMEI eliminado", "success");
          })
          .catch((err) => console.log(err));
      }
    });
  }

  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 };

  return (
    <>
      <Header />
      <br />
      <br />
      {(user.menu_compras || user.menu_inventarios) ? (
        <div className="card container col-12">
          {/* Toolbar */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, marginTop: 8 }}>
            <h4 style={{ margin: 0 }}>
              📱 Registro de IMEIs
              <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontWeight: 700, fontSize: "0.85rem", marginLeft: 10 }}>
                {filtered.length} registros
              </span>
            </h4>
            <Button size="sm" color="danger" href={user.menu_compras ? "/MenuCompras" : "/MenuInventarios"}>← Regresar</Button>
          </div>

          {/* Filtros */}
          <div style={block}>
            <div style={sec}>🔍 Filtros</div>
            <Row>
              <Col md={2}>
                <Label>Fecha Inicio</Label>
                <Input type="date" value={filterFechaInicio} onChange={(e) => setFilterFechaInicio(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Fecha Fin</Label>
                <Input type="date" value={filterFechaFin} onChange={(e) => setFilterFechaFin(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Tipo</Label>
                <Input type="select" value={filterTipo} onChange={(e) => setFilterTipo(e.target.value)}>
                  <option value="">Todos</option>
                  <option value="Entrada">Entrada</option>
                  <option value="Salida">Salida</option>
                </Input>
              </Col>
              <Col md={4}>
                <Label>Buscar IMEI / Artículo</Label>
                <Input type="text" placeholder="Buscar..." value={search} onChange={(e) => setSearch(e.target.value)} />
              </Col>
            </Row>
          </div>

          {/* Tabla */}
          <div style={block}>
            <div style={sec}>📋 IMEIs Registrados</div>
            <Table size="sm" bordered striped className="table-responsive-xl" style={{ fontSize: "0.82rem" }}>
              <thead className="thead-light">
                <tr>
                  <th>#</th>
                  <th>Fecha</th>
                  <th>IMEI</th>
                  <th>Artículo</th>
                  <th>Tipo</th>
                  <th>Doc. Referencia</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((i) => (
                  <tr key={i._id} style={i.tipo === "Entrada" ? { backgroundColor: "#dcfce7" } : { backgroundColor: "#dbeafe" }}>
                    <td>{i.idIMEI}</td>
                    <td>{i.fecha}</td>
                    <td><b>{i.imei}</b></td>
                    <td>{i.articuloNombre}</td>
                    <td>
                      <Badge color={i.tipo === "Entrada" ? "success" : "primary"} pill>
                        {i.tipo}
                      </Badge>
                    </td>
                    <td>
                      {i.tipo === "Entrada" && i.compras
                        ? `Entrada #${i.compras?.idCompras || ""}`
                        : i.tipo === "Salida" && i.surtidos
                        ? `Surtido #${i.surtidos?.idSurtido || ""}`
                        : "—"}
                    </td>
                    <td>
                      {user.menu_compras ? (
                        <Button size="sm" color="danger" onClick={() => eliminarIMEI(i._id)}>
                          <i className="fas fa-trash"></i>
                        </Button>
                      ) : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default ListadoIMEIs;
